import styled from 'styled-components';
import { constructCss, getBorderCssOutput, getBoxOrSizeCssOutput } from './crate.utils.js';

const styledCrateCssConstructor = (props) => constructCss(props, {
    'background-color': ({ getStyledPropValue, theme }) => {
        const backgroundColor = getStyledPropValue('backgroundColor');
        return backgroundColor
            ? theme.colors.background[backgroundColor]
            : undefined;
    },
    'border-bottom': ({ getStyledPropValue, theme }) => {
        const border = getStyledPropValue('border');
        if (!border)
            return undefined;
        return getBorderCssOutput(border, 'bottom', theme);
    },
    'border-left': ({ getStyledPropValue, theme }) => {
        const border = getStyledPropValue('border');
        if (!border)
            return undefined;
        return getBorderCssOutput(border, 'left', theme);
    },
    'border-right': ({ getStyledPropValue, theme }) => {
        const border = getStyledPropValue('border');
        if (!border)
            return undefined;
        return getBorderCssOutput(border, 'right', theme);
    },
    'border-top': ({ getStyledPropValue, theme }) => {
        const border = getStyledPropValue('border');
        if (!border)
            return undefined;
        return getBorderCssOutput(border, 'top', theme);
    },
    'border-radius': ({ getStyledPropValue }) => {
        const borderRadius = getStyledPropValue('borderRadius');
        if (!borderRadius)
            return undefined;
        if (typeof borderRadius === 'string') {
            return borderRadius;
        }
        const { topLeft = '0px', bottomLeft = '0px', topRight = '0px', bottomRight = '0px', } = borderRadius;
        return `${topLeft} ${topRight} ${bottomRight} ${bottomLeft}`;
    },
    bottom: ({ getStyledPropValue }) => getStyledPropValue('bottom'),
    display: ({ getStyledPropValue }) => getStyledPropValue('display'),
    flex: ({ getStyledPropValue }) => getStyledPropValue('flex'),
    'flex-basis': ({ getStyledPropValue }) => getStyledPropValue('flexBasis'),
    'flex-grow': ({ getStyledPropValue }) => {
        const flexGrow = getStyledPropValue('flexGrow');
        if (typeof flexGrow !== 'undefined') {
            return `${flexGrow}`;
        }
        return undefined;
    },
    'flex-shrink': ({ getStyledPropValue }) => {
        const flexShrink = getStyledPropValue('flexShrink');
        if (typeof flexShrink !== 'undefined') {
            return `${flexShrink}`;
        }
        return undefined;
    },
    height: ({ getStyledPropValue }) => getStyledPropValue('height'),
    'justify-self': ({ getStyledPropValue }) => getStyledPropValue('justifySelf'),
    left: ({ getStyledPropValue }) => getStyledPropValue('left'),
    margin: ({ getStyledPropValue }) => {
        const margin = getStyledPropValue('margin');
        if (!margin)
            return undefined;
        return getBoxOrSizeCssOutput(margin);
    },
    'max-height': ({ getStyledPropValue }) => getStyledPropValue('maxHeight'),
    'max-width': ({ getStyledPropValue }) => getStyledPropValue('maxWidth'),
    'min-height': ({ getStyledPropValue }) => getStyledPropValue('minHeight'),
    'min-width': ({ getStyledPropValue }) => getStyledPropValue('minWidth'),
    overflow: ({ getStyledPropValue }) => getStyledPropValue('overflow'),
    padding: ({ getStyledPropValue }) => {
        const padding = getStyledPropValue('padding');
        if (!padding)
            return undefined;
        return getBoxOrSizeCssOutput(padding);
    },
    position: ({ getStyledPropValue }) => getStyledPropValue('position'),
    right: ({ getStyledPropValue }) => getStyledPropValue('right'),
    top: ({ getStyledPropValue }) => getStyledPropValue('top'),
    transition: ({ getStyledPropValue }) => getStyledPropValue('transition'),
    width: ({ getStyledPropValue }) => getStyledPropValue('width'),
    'z-index': ({ getStyledPropValue }) => {
        const zIndex = getStyledPropValue('zIndex');
        return typeof zIndex === 'undefined' ? undefined : `${zIndex}`;
    },
});
const StyledCrate = styled.div `
  box-sizing: border-box;
  ${styledCrateCssConstructor}
`;

export { StyledCrate, styledCrateCssConstructor };
